import './styles/index.css'
import ActiveStepStatus from '../../assets/icons/active-step-icon.svg'
import CompleteStepStatus from '../../assets/icons/complete-step-icon.svg'
import InactiveStepStatus from '../../assets/icons/inactive-step-icon.svg'

export const StepperStep = ({
  isFirstActive,
  isLastActive,
  isFirstStep,
  isLastStep,
  stepName,
  isCompleted,
  isCurrent,
  stepDescription,
  handleGoToStep
}: {
  isFirstActive?: boolean
  isLastActive?: boolean
  isFirstStep?: boolean
  isLastStep?: boolean
  stepName: string
  isCompleted?: boolean
  isCurrent: boolean
  stepDescription: string
  handleGoToStep?: (stepToGo: number) => void
}) => {
  return (
    <div
      className="stepper-step-container"
      onClick={() => handleGoToStep?.(Number(stepName.split(' ')[1]))}
    >
      <div className="step-status">
        <hr
          style={isFirstStep ? { opacity: '0' } : {}}
          className={isFirstActive ? 'active' : ''}
        />
        {isCompleted ? (
          <img
            src={CompleteStepStatus}
            alt="stepper-status"
          />
        ) : isCurrent ? (
          <img
            src={ActiveStepStatus}
            alt="stepper-status"
          />
        ) : (
          <img
            src={InactiveStepStatus}
            alt="stepper-status"
          />
        )}
        <hr
          style={isLastStep ? { opacity: '0' } : {}}
          className={isLastActive ? 'active' : ''}
        />
      </div>
      <div className="step-name">{stepName}</div>
      <div className="step-description">{stepDescription}</div>
    </div>
  )
}
